import CourseStructuresUploadContainer from './CourseStructuresUploadContainer';
export default CourseStructuresUploadContainer;
